import PhotosFilled from './src/photos-filled';
export default PhotosFilled;